import styled, { css } from 'styled-components';

import { BackgroundImageUrls } from 'approot/shared/layout/layout.constants';
import { coolGrey1 } from 'approot/shared/styles/colours.style';
import { mediaUp } from 'approot/shared/style';

type PresentationBackgroundProps = {
  $backgroundColour?: string;
  $backgroundImage?: BackgroundImageUrls;
};

export const PresentationBackground = styled.div<PresentationBackgroundProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  ${({ $backgroundColour = coolGrey1 }) => `
    background-color: ${$backgroundColour};
  `}

  ${({ $backgroundImage }) =>
    $backgroundImage &&
    css`
      background-image: url(${$backgroundImage.base});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;

      ${mediaUp.lg`
        background-image: url(${$backgroundImage.l});
      `}

      ${mediaUp.xl`
        background-image: url(${$backgroundImage.xl});
      `}

      @media (min-width: 1401px) {
        background-image: url(${$backgroundImage.xxl});
      }

      @media (min-width: 2001px) {
        background-image: url(${$backgroundImage.xxxl});
      }
    `}
`;
